// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Maschinentransport, MaschinentransportDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateMaschinentransport(): (
  taetigkeitsberichtId: string,
  fuhrparkeintragId: string,
  maschinentransportId: string,
  requestBody: MaschinentransportDaten
) => Promise<Maschinentransport> {
  const getAPI = useGetApi();
  return useCallback(
    async (
      taetigkeitsberichtId,
      fuhrparkeintragId,
      maschinentransportId,
      requestBody
    ) =>
      (await getAPI()).maschinentransporte.updateMaschinentransport({
        taetigkeitsberichtId,
        fuhrparkeintragId,
        maschinentransportId,
        requestBody,
      }),
    [getAPI]
  );
}
